import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding: 30px;
  max-width: 675px;
  width: 88vw;
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  img {
    /* max-width: 100px;
    width: 100px; */
    display: block;
    margin: 15px 0;
  }
  h4 {
    font-size: 19px;
    margin: 0;
  }
  p {
    margin-top: 3px;
    font-size: 14px;
  }
  Button {
    border-radius: 15px;
    padding: 0.5em 1em;
    background: #000;
  }
`;
const Body = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 0;
  }
  button {
    background-color: ${COLORS.BLACK};
    font-size: 15px;
    border-radius: 50px;
    padding: 8px 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    font-weight: 700;
    :hover {
      background-color: ${COLORS.BLACK};
    }
    :last-child {
      background-color: transparent;
      color: ${COLORS.BODY_TEXT};
      box-shadow: none;
      text-transform: capitalize;
    }
  }
`;

const ForgetPassword = styled.a`
  padding: 15px 0;
  color: #000;
  cursor: pointer;
  width: fit-content;
  margin: 0 auto;
  text-decoration: underline;
  font-size: 15px;
  &:hover {
    color: #ccc;
  }
`;

const ActionButton = styled.div`
  display: flex;
  grid-gap: 15px;
`;

export { Container, Header, Body, ForgetPassword, ActionButton };
